import React from 'react';
import './icon.scss';
import { IconProps } from '../../types/icons';

const PenIcon: React.FC<IconProps> = ({
  fill,
  color,
  width = 24,
  height,
  onClick,
  className = '',
}) => {
  const classBase = 'custom-icon';
  const classes = `${classBase} ${classBase}-color-${color} ${className}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height || width}
      className={classes}
      fill={fill || '#7E8A96'}
      onClick={onClick}
      data-testid="pen-icon"
      viewBox="0 0 22 21"
    >
      <path
        fill={fill || '#7E8A96'}
        fillRule="evenodd"
        d="M19.764.293a1 1 0 00-1.415 0l-.872.872a3.001 3.001 0 00-3.415.587L3.455 12.358l5.657 5.657L19.72 7.408c.924-.923 1.119-2.3.586-3.414l.873-.873a1 1 0 000-1.414L19.763.293zm-4.268 8.51l-6.384 6.384-2.828-2.829 6.383-6.383 2.829 2.829zm1.818-1.818l.99-.99a1 1 0 000-1.415l-1.413-1.414a1 1 0 00-1.415 0l-.99.99 2.828 2.83z"
        clipRule="evenodd"
      />
      <path
        fill={fill || '#7E8A96'}
        d="M.5 20.95l2.122-7.778 5.656 5.657L.5 20.95z"
      />
    </svg>
  );
};

export default PenIcon;
